/**
 * Created by matheusmorett on 16/08/17.
 */
import React, { Component } from 'react';
import './BalloonPopUp.scss';

class BalloonPopUp extends Component {

    static defaultProps = {
        items: [],
        onClick: () => { },
        onClose: () => { },
        onClickItem: () => { },
        open: false,
        selectedValue: '',
        disabled: false
    };

    constructor(props) {
        super(props);

        this.onClose = this.onClose.bind(this)
        this.onOpen = this.onOpen.bind(this)
        this.onClickItem = this.onClickItem.bind(this)
    }

    onClose() {
        document.body.classList.remove('disable-scroll')
        this.props.onClose()
    }

    onOpen() {
        document.body.classList.add('disable-scroll')
        this.props.onClick()
    }

    onClickItem(e) {
        this.props.onClickItem(e)
        this.onClose()
    }

    render() {
        return (
            <div className={`BalloonPopUp ${this.props.disabledClick ? 'disable-click' : ''} ${this.props.disabled ? 'disabled' : ''}`}>
                <div className={`dropdown-backdrop ${this.props.open ? '' : 'closed'}`} onClick={() => this.onClose()}></div>
                <div className={`dropdown-value ${this.props.selectedValue ? 'border-active': ''}`} onClick={() => this.onOpen()}>
                    <div className='icon-dropdown'>
                    <i className='icon icon-clock' />
                </div>
                <h4 className={(this.props.selectedValue && "active")}>{(this.props.selectedValue) ? this.props.selectedValue : "Selecione"}</h4>
            </div>
            <List
                onClickItem={this.onClickItem}
                items={this.props.items}
                showing={this.props.open} />
            </div >
        )
    }
}

const List = ({ items, onClickItem, showing }) => (
    <div className={`list-dropdown ${showing ? '' : 'closed'}`}>
        <div className='list-content'>
            {items.map((item, index) => (
                <div key={index} className="hour btn-secondary" onClick={() => onClickItem(item)}>
                    {item.name}
                </div>
            ))}
        </div>
    </div>
);

export default BalloonPopUp